module.exports = "/_next/static/images/7f00f42aebe965591aae1f978ac3dbbe-prepayment_limitbar.png.webp";